/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Fri Apr 12 2024
 **/

import { _T } from "@rfice/language";

/**
 * 마이룸 (상대방 포함)의 이름을 반환하는 함수입니다.
 */
export default function getMyRoomName(myRoomInfo?: WebServices.MyRoom.Inquiry.Data) {
	if (!myRoomInfo) return null;
	const { ownerProfile, owner, name } = myRoomInfo;
	if (name) {
		return name;
	}
	if (owner) {
		return _T("마이룸");
	} else {
		return _T("{{name}}의 마이룸", { name: ownerProfile.name });
	}
}
